// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalTable_root__1b_A8"};